import React from "react";

const ScreenContainer = ({ children }) => {
  return <div style={{ padding: "12px" }}>{children}</div>;
};

export default ScreenContainer;
